import { useEffect, useState, Dispatch, SetStateAction } from 'react'

type SetValue<T> = Dispatch<SetStateAction<T>>
export default function useLocalStorage<T>(
	key: string,
	fallbackValue: T,
	skipLoadStoredValue?: Boolean
): [T | null, SetValue<T | null>] {
	const [value, setValue] = useState<T | null>(null)

	useEffect(() => {
		if (typeof localStorage !== 'undefined' && (value || value === undefined)) {
			if (value === undefined) {
				localStorage.removeItem(key)
			} else if (typeof value === 'string') {
				localStorage.setItem(key, value)
			} else if (typeof value === 'object') {
				localStorage.setItem(key, JSON.stringify(value))
			}
		}
	}, [value])

	useEffect(() => {
		const stored = localStorage.getItem(key)
		if (skipLoadStoredValue || !stored) {
			setValue(fallbackValue)
		} else if (stored) {
			try {
				const parsedValue = JSON.parse(stored)
				setValue(parsedValue)
			} catch (error) {
				setValue(stored as T)
			}
		}
	}, [])

	return [value, setValue]
}
